import { ModelStore } from '@/tools/models/model.store';

/**
 * Store for models within the tool pane.
 * Models can be created and edited in multiple places (e.g. tool pane, scaling tables)
 * so we need a dedicated store for the model tool to avoid conflicts with other places.
 */
export class ToolModelStore extends ModelStore {
  static readonly storeName = 'sqToolModelStore';

  protected override readonly handlers = {
    ...this.baseHandlers,
    TOOL_MODEL_RESET_MODEL: this.resetModel,
    TOOL_MODEL_SET_MODEL: this.setModel,
    TOOL_MODEL_SET_FEATURE_TO_EDIT_ID: this.setFeatureToEditId,
    TOOL_MODEL_SET_INSTANCE_TO_EDIT_ID: this.setInstanceToEditId,
  };
}
